var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAccordionActions from '@material-ui/core/AccordionActions';
/**
 * Kareo wrapped component of the Material-UI AccordionActions. The prop API has been limited to props defined in AccordionActionsProps.
 *
 * Material-UI AccordionActions: [Docs](https://v4.mui.com/components/accordion/), [API](https://v4.mui.com/api/accordion-actions/)
 *
 * @storybook: [Accordion](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-accordion--simple-and-disabled-accordion)
 */
var AccordionActions = React.forwardRef(function (props, ref) { return (React.createElement(MuiAccordionActions, __assign({}, props, { ref: ref }))); });
AccordionActions.displayName = 'KareoAccordionActions';
export default AccordionActions;
